/**
 * Abschluss-Modal — erscheint EINMALIG, wenn das Großziel erreicht wird
 * (Web-Parität zu certificate.js). Glückwunsch + Urkunde laden + Weiterlernen.
 * Gesteuert über das certModal-Signal (state/completion.ts).
 */
import { certModal, downloadCertificate } from "../state/completion";
import { Modal } from "../ui/Modal";
import { showToast } from "../ui/toast";

export function CertificateModal() {
  const res = certModal.value;
  if (!res) return null;

  async function onDownload() {
    const ok = await downloadCertificate();
    if (!ok) showToast("Urkunde konnte nicht geladen werden.");
  }
  function close() {
    certModal.value = null;
  }

  return (
    <Modal onClose={close}>
      <h2>🎉 Großziel erreicht!</h2>
      <p>
        Herzlichen Glückwunsch — du hast den Kurs geschafft. Deine Abschluss-Urkunde
        steht bereit{res.certificate?.mail_status === "sent" ? " und ist dir auch per E-Mail zugegangen" : ""}.
      </p>
      {res.certificate?.id ? (
        <p class="text-muted" style="font-size:12px;margin:6px 0 0">Zertifikats-Nr.: {res.certificate.id}</p>
      ) : null}
      <div class="chapter-confirm-actions">
        <button class="btn-ghost" onClick={close}>Weiter lernen</button>
        <button class="btn-coach" onClick={onDownload}>Urkunde herunterladen</button>
      </div>
    </Modal>
  );
}
